<template>
    <Card :bordered="false" class="border-radius-0">
        <CardBorder :title="$t('views.feeStatement.title')">
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading || props.isLoadingProp"></TemplateBuilder>
            </Form>
        </CardBorder>
        <CardBorder v-if="['waitPayment', 'waitApprovePayment', 'approvePayment'].includes(data.useForm.modelRef?.refPaymentStatus?.key)" :title="$t('views.feeStatement.informPaymentInfo')">
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.informPaymentFields" :skeleton="isLoading || props.isLoadingProp"></TemplateBuilder>
            </Form>
        </CardBorder>
        <ChangeLogCollapse
            class="mt-2"
            v-if="visibleChangeLog && data.id"
            :id="data.id"
            :onCallChangeLog="({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })"
            :mappings="data.fieldLogs"
        ></ChangeLogCollapse>
    </Card>
</template>

<script>
    import { Card, Form } from "ant-design-vue";
    import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { state as stateApp } from "../../../../app.logic";
    import { onCallChangeLog } from "../../../../utils/form";
    import { callChanges, createFormTitle, initData, initForm, isLoading, state, createSearchOneCriteria } from "./request.logic";

    export default defineComponent({
    components: {
        Card,
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        CardBorder: defineAsyncComponent(() => import("../../../../components/card/CardBorder")),
        ChangeLogCollapse: defineAsyncComponent(() => import("../../../../components/change-log/ChangeLogCollapse")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "fee-statements" },
        viewOnly: { default: false },
        form: {},
        dataProp: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        itemsKey: { default: "feeStatements"},
        visible: { default: true },
        dataKey: {},
        isLoadingProp: {},
    },
    setup(props) {
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = props.dataProp ? reactive({ ...props.dataProp }) : reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [] });
        const refs = reactive({ form: null });
        if (props.dataProp) {
            initData({ props, data, refs });
        } else {
            initForm({ props, data, refs, route });
        }
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callChanges,
            createSearchOneCriteria,
            onCallChangeLog
        };
    }
});
</script>
